// Placeholder bot config hook
const useBotConfig = () => ({
  currentBotConfig: {
    id: 'bot-1',
    name: 'Placeholder Bot',
    homeScreen: { title: 'Welcome', subtitle: 'How can I help?', inputPlaceholder: 'Type here...' },
    warning: { text: 'Warning text', icon: () => null },
    botName: 'speciality-match' as const,
    finalFeedbackText: 'Thank you for your feedback!',
    themeName: 'TELEHEALTH_TRIAGE_BOT',
  },
});

export default useBotConfig;
